module.exports = __webpack_public_path__ + "img/contact_bg.0f65371.png";